export default __webpack_public_path__ + "static/media/pos_icon.639270f0.svg";